//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { InstagramPostDetailsMetadataActions } from '@instagram-account/redux/post-details/metadata/instagramPostDetailsMetadataActions';
import {
  IInstagramPostDetailsMetadataState,
  INSTAGRAM_POST_DETAILS_METADATA_ACTIONS,
} from '@instagram-account/redux/post-details/metadata/instagramPostDetailsMetadataModel';

const initialState: IInstagramPostDetailsMetadataState = {
  eligibleUsers: [],
  flags: {
    isFetchingLocationSuggestions: false,
  },
  locationSearchText: undefined,
  locationSuggestions: [],
};

export default function InstagramPostDetailsMetadataReducer(
  state: IInstagramPostDetailsMetadataState = initialState,
  action: InstagramPostDetailsMetadataActions,
): IInstagramPostDetailsMetadataState {
  switch (action.type) {
    case INSTAGRAM_POST_DETAILS_METADATA_ACTIONS.SET_ELIGIBLE_USERS: {
      return {
        ...state,
        eligibleUsers: action.eligibleUsers,
      };
    }
    case INSTAGRAM_POST_DETAILS_METADATA_ACTIONS.SET_LOCATION_SEARCH_TEXT: {
      return {
        ...state,
        locationSearchText: action.locationSearchText,
      };
    }
    case INSTAGRAM_POST_DETAILS_METADATA_ACTIONS.REQUEST_LOCATIONS: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingLocationSuggestions: true,
        },
      };
    }
    case INSTAGRAM_POST_DETAILS_METADATA_ACTIONS.RECEIVE_LOCATIONS_SUCCEEDED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingLocationSuggestions: false,
        },
        locationSuggestions: action.locationSuggestions,
      };
    }
    case INSTAGRAM_POST_DETAILS_METADATA_ACTIONS.RECEIVE_LOCATIONS_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          isFetchingLocationSuggestions: false,
        },
        locationSuggestions: initialState.locationSuggestions,
      };
    }
  }
  return state;
}
